import { apiSlice } from './apiSlice';

const noteApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createNote: builder.mutation({
      query: ({ author, title, content, category, relatedCafes, attachmentData }) => ({
        url: `/notes`,
        method: 'POST',
        body: {
          author,
          title,
          content,
          category,
          relatedCafes,
          attachmentData,
        },
      }),
      invalidatesTags: ['NoteDetail', 'UserProfile'],
    }),

    getNoteInfo: builder.query({
      query: (_id) => `/notes/${_id}`,
      providesTags: ['NoteDetail'],
    }),

    // getNoteGallery: builder.query({
    //   query: () => `/notes/gallery`,
    //   providesTags: ['NoteGallery'],
    // }),

    getNoteGallery: builder.mutation({
      query: ({ noteNum, pageNum }) => ({
        url: `/notes/gallery`,
        method: 'POST',
        body: {
          noteNum,
          pageNum,
        },
      }),
      invalidatesTags: ['NoteGallery'],
    }),

    likeNote: builder.mutation({
      query: ({ noteId, userId }) => ({
        url: `/notes/${noteId}/like`,
        method: 'PUT',
        body: {
          userId,
        },
      }),
      invalidatesTags: ['NoteDetail', 'UserProfile'],
    }),

    unlikeNote: builder.mutation({
      query: ({ noteId, userId }) => ({
        url: `/notes/${noteId}/unlike`,
        method: 'PUT',
        body: {
          userId,
        },
      }),
      invalidatesTags: ['NoteDetail', 'UserProfile'],
    }),

    saveNote: builder.mutation({
      query: ({ noteId, userId }) => ({
        url: `/notes/${noteId}/save`,
        method: 'PUT',
        body: {
          userId,
        },
      }),
      invalidatesTags: ['NoteDetail', 'UserProfile'],
    }),

    unsaveNote: builder.mutation({
      query: ({ noteId, userId }) => ({
        url: `/notes/${noteId}/unsave`,
        method: 'PUT',
        body: {
          userId,
        },
      }),
      invalidatesTags: ['NoteDetail', 'UserProfile'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateNoteMutation,
  useGetNoteInfoQuery,
  useLikeNoteMutation,
  useUnlikeNoteMutation,
  useSaveNoteMutation,
  useUnsaveNoteMutation,
  useGetNoteGalleryMutation,
} = noteApi;
